import { $ as e, Q as t, Z as n, a as r, c as i, d as a, f as o, i as s, l as c, n as l, o as u, r as d, s as f, t as p, u as m } from "./sdk.gen-s8MJGGfo.js";
//#region src/utils/querySerializer.ts
var h = (e) => {
	switch (e) {
		case "label": return ".";
		case "matrix": return ";";
		case "simple": return ",";
		default: return "&";
	}
}, g = (e) => {
	switch (e) {
		case "form": return ",";
		case "pipeDelimited": return "|";
		case "spaceDelimited": return "%20";
		default: return ",";
	}
}, _ = (e) => {
	switch (e) {
		case "label": return ".";
		case "matrix": return ";";
		case "simple": return ",";
		default: return "&";
	}
}, v = ({ allowReserved: e, explode: t, name: n, style: r, value: i }) => {
	if (!t) {
		let t = (e ? i : i.map((e) => encodeURIComponent(e))).join(g(r));
		switch (r) {
			case "label": return `.${t}`;
			case "matrix": return `;${n}=${t}`;
			case "simple": return t;
			default: return `${n}=${t}`;
		}
	}
	let a = h(r), o = i.map((t) => r === "label" || r === "simple" ? e ? t : encodeURIComponent(t) : x(n, t, { allowReserved: e })).join(a);
	return r === "label" || r === "matrix" ? a + o : o;
}, y = ({ allowReserved: e, name: t, value: n }) => n == null ? "" : `${t}=${e ? n : encodeURIComponent(n)}`, b = ({ allowReserved: e, explode: t, name: n, style: r, value: i, valueOnly: a }) => {
	if (i instanceof Date) return a ? i.toISOString() : `${n}=${i.toISOString()}`;
	if (r !== "deepObject" && !t) {
		let t = [];
		Object.entries(i).forEach(([n, r]) => {
			t = [
				...t,
				n,
				e ? r : encodeURIComponent(r)
			];
		});
		let a = t.join(",");
		switch (r) {
			case "form": return `${n}=${a}`;
			case "label": return `.${a}`;
			case "matrix": return `;${n}=${a}`;
			default: return a;
		}
	}
	let o = _(r), s = Object.entries(i).map(([t, i]) => x(r === "deepObject" ? `${n}[${t}]` : t, i, { allowReserved: e })).join(o);
	return r === "label" || r === "matrix" ? o + s : s;
}, x = (e, t, { allowReserved: n, array: r, object: i } = {}) => t == null ? "" : Array.isArray(t) ? v({
	allowReserved: n,
	explode: !0,
	name: e,
	style: "form",
	value: t,
	...r
}) : typeof t == "object" ? b({
	allowReserved: n,
	explode: !0,
	name: e,
	style: "deepObject",
	value: t,
	...i
}) : y({
	allowReserved: n,
	name: e,
	value: t
}), S = ({ allowReserved: e, array: t, object: n } = {}) => (r) => {
	let i = [];
	if (r && typeof r == "object") for (let a in r) {
		let o = r[a], s = x(a, o, {
			allowReserved: e,
			array: t,
			object: n
		});
		s && i.push(s);
	}
	return i.join("&");
}, C = () => n.getConfig().auth, w = (r = { token: void 0 }) => {
	if (!r.token) throw Error("Token is required");
	let i = {
		baseUrl: e,
		auth: r.token,
		querySerializer: S()
	};
	return r.environment && r.environment === "acceptance" && (i.baseUrl = t), r.locale && (i.headers = {
		...i.headers,
		"Accept-Language": r.locale
	}), n.setConfig(i), r.token;
}, T = (e) => {
	n.setConfig({ headers: {
		...n.getConfig().headers,
		"Accept-Language": e
	} });
}, E = async (e) => (await i({ body: e })).data, D = async (e) => (await o({ body: e })).data, O = async (e) => (await m({ body: e })).data, k = async (e) => (await u({ body: e })).data, A = async (e) => (await a({ body: e })).data, j = async (e) => (await f({ body: e })).data, M = async (e) => (await p({ query: e })).data, N = async (e) => (await r({ body: e })).data, P = async (e) => (await c({ body: e })).data, F = async (e) => (await d({ body: e })).data, I = async (e) => (await s({ body: e })).data, L = async (e) => {
	let t = n.getConfig().headers;
	return (await l({
		client: n,
		path: e.path,
		query: e.query,
		headers: {
			Accept: "application/pdf",
			"Accept-Language": t?.["Accept-Language"],
			"content-type": "application/json"
		},
		requestValidator: (e) => e
	})).data;
};
/* c8 ignore end */
function R() {
	return {
		getToken: C,
		initClient: w,
		setAcceptLanguageHeader: T,
		postRemoveLines: E,
		postUpdateLineQuantity: D,
		postSetDeliveryType: O,
		postRegister: k,
		postSetExpectedDelivery: A,
		postRemove: j,
		getPurchaseOrders: M,
		postSetDeliverySupplierDetails: P,
		postCreate: N,
		postAddLines: F,
		postCancel: I,
		getPurchaseOrderPackingSlip: L
	};
}
//#endregion
export { R as t };
